import React from "react";
import styled from "styled-components";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";

//
import EYEIMG from "../assets/images/main-book-app-eye.png";

export default function BookAppointment() {
  const { t } = useTranslation();

  return (
    <StyledBookAppointment>
      <div className="container">
        <div className="bookApp__wrap">
          <div className="bookApp__top">
            <h1 dangerouslySetInnerHTML={{ __html: t("bookAppTitle") }} />
          </div>
          <div className="bookApp__bottom">
            <ul className="bookApp__list">
              <li className="bookApp__list__item">
                <h2>{t("bookAppcataractSurgeryTitle")}</h2>
                <p>{t("bookAppcataractSurgeryText")}</p>
                <Link to="/about/eye-disease/1" className="hover-underline" >
                  {t("bookAppLink")}{" "}
                  <i className="icon icon-long-arrow-alt-right"></i>{" "}
                </Link>
              </li>
              <li className="bookApp__list__item">
                <h2>{t("bookAppdiabetDiseaseTitle")}</h2>
                <p>{t("bookAppdiabetDiseaseText")}</p>
                <Link to="/about/eye-disease/2" className="hover-underline" >
                  {t("bookAppLink")}{" "}
                  <i className="icon icon-long-arrow-alt-right"></i>{" "}
                </Link>
              </li>
            </ul>
            <div className="bookApp__img">
              <img src={EYEIMG} alt="EYEIMG" loading="lazy" decoding="async" />
            </div>
            <ul className="bookApp__list">
              <li className="bookApp__list__item">
                <h2>{t("bookAppglaucomaScreeningTitle")}</h2>
                <p>{t("bookAppglaucomaScreeningText")}</p>
                <Link to="/about/eye-disease/3"  className="hover-underline">
                  {t("bookAppLink")}{" "}
                  <i className="icon icon-long-arrow-alt-right"></i>{" "}
                </Link>
              </li>
              <li className="bookApp__list__item">
                <h2>{t("bookAppmyopiaTherapyTitle")}</h2>
                <p>{t("bookAppmyopiaTherapyText")}</p>
                <Link to="/about/eye-disease/4"  className="hover-underline">
                  {t("bookAppLink")}{" "}
                  <i className="icon icon-long-arrow-alt-right"></i>{" "}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </StyledBookAppointment>
  );
}

const StyledBookAppointment = styled.section`
  padding: 140px 0;
  background-color: var(--white);

  .bookApp {
    &__top {
      margin-bottom: 48px;

      h1 {
        color: var(--title);
        text-align: center;
        font-size: var(--fs-section-title);
        font-style: normal;
        font-weight: var(--fw-semibold);
        line-height: var(--lh-title);

        span {
          color: var(--light-blue);
          font-size: var(--fs-card-title);
          font-weight: var(--fw-medium);
        }
      }
    }

    &__bottom {
      display: flex;
      justify-content: space-around;
    }

    &__list {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 48px;
      width: max-content;

      &__item {
        h2 {
          color: var(--title);
          font-size: var(--fs-card-title);
          font-style: normal;
          font-weight: var(--fw-semibold);
          line-height: 1.35;
          margin-bottom: 16px;
          max-width: 350px;
        }

        p {
          color: var(--text);
          font-size: var(--fs-body);
          font-style: normal;
          font-weight: var(--fw-regular);
          line-height: var(--lh-body);
          max-width: 330px;
          margin-bottom: 24px;
          text-align: left;
        }

        a {
          color: var(--light-blue);
          font-size: var(--fs-body);
          font-style: normal;
          font-weight: var(--fw-medium);
          line-height: var(--lh-body);
          display: flex;
          align-items: center;
          gap: 10px;
          width: max-content;

          i {
            width: 18px;
            height: 18px;
            background-color: var(--light-blue);
          }

          &::after {
            background-color: var(--light-blue);
          }
        }
      }
    }

    &__img {
      display: flex;
      align-items: center;

      img {
        transition: 0.4s ease;
        vertical-align: middle;

        &:hover {
          transform: scale(0.9);
        }
      }
    }
  }
`;
